// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import resolutionEntity from './entities/resolution.json';
import resolutionMenu from '../pages/resolution/menu.json';
import resolutionFullForm from '../pages/resolution/forms/full.json';
import resolutionContextForm from '../pages/resolution/forms/context.json';
import resolutionMiniForm from '../pages/resolution/forms/mini.json';
import resolutionLookupForm from '../pages/resolution/forms/lookup.json';
import resolutionTableView from '../pages/resolution/views/table.json';
import resolutionStagesView from '../pages/resolution/views/stages.json';
import resolutionBacklogView from '../pages/resolution/views/backlog.json';
import resolutionSplitView from '../pages/resolution/views/split.json';
import resolutionCardsView from '../pages/resolution/views/cards.json';
import resolutionCalendarView from '../pages/resolution/views/calendar.json';
import resolutionDashboardView from '../pages/resolution/views/dashboard.json';

/** Тип запису «Постанова» зі сторінками пакета: меню, форми та подання з pages/resolution/. */
export const resolutionDefinition: IRecordTypeDefinition = {
  ...resolutionEntity,
  views: assembleViewSet({
      table: resolutionTableView,
      stages: resolutionStagesView,
      backlog: resolutionBacklogView,
      split: resolutionSplitView,
      cards: resolutionCardsView,
      calendar: resolutionCalendarView,
      dashboard: resolutionDashboardView,
  }),
  form: resolutionFullForm,
  forms: { full: resolutionFullForm, context: resolutionContextForm, mini: resolutionMiniForm, lookup: resolutionLookupForm },
  menu: resolutionMenu,
} as IRecordTypeDefinition;
